let featuredResourcesLink = document.querySelectorAll('.FeaturedResources-link');

if (featuredResourcesLink) {
  featuredResourcesLink.forEach(elm => {
    elm.addEventListener('mouseenter', (event) => {
      let { target } = event;
      let card = target.closest('.FeaturedResources-card');
      let img = card.querySelector('.FeaturedResources-img-src');

      if (!img) {
        return false;
      }

      img.classList.toggle('is-hover');
    });

    elm.addEventListener('mouseleave', (event) => {
      let { target } = event;
      let card = target.closest('.FeaturedResources-card');
      let img = card.querySelector('.FeaturedResources-img-src');

      if (!img) {
        return false;
      }

      img.classList.toggle('is-hover');
    });
  });
}